export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deposit.vue?vue&type=template&id=a6540c38&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/deposit.vue?vue&type=template&id=a6540c38&scoped=true
// module id = UVBZ
// module chunks = 0